import digitalData from 'digital-data';
import { PIP_SUB_CONTENT, INTERACTION, SYSTEM } from '../constants';

export const calculator = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('@@CALCULATOR/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@CALCULATOR/CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('@@CALCULATOR/TIPS_CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@CALCULATOR/TIPS_CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('calculator.click', (payload) => {
    const ddoEvent = {
      eventInfo: {
        eventName: PIP_SUB_CONTENT
      },
      category: {
        primaryCategory: INTERACTION
      },
      subContent: {
        section: 'buybox',
        component: SYSTEM,
        target: 'quantity calculator',
        position: ''
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('calculator.click-tips', ({ output }) => {
    const {
      eventName, primaryCategory
    } = output;
    const thdAnalyticsEvent = {
      eventInfo: {
        eventName
      },
      category: {
        primaryCategory
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(thdAnalyticsEvent);
  });
};
